import React from 'react';
import clsx from 'clsx';

const CouponTile = ({ kouponData, kouponConsumerIdentifier }) => {
    const { id, offer_id, company_id, image_url, instructions, 
        title, subtitle, value, visible, start_date, end_date,
        koupon_offer_products,  created_at, updated_at } = kouponData;

    const handleCouponBoxClick = () => {
        const kouponOffer = kouponData;

        // Dispatch custom event to show addToCart modal
        const event = new CustomEvent('showAddToCartModal', {
            detail: {
                type: 'koupon',
                product: kouponOffer,
                isOrderAgain: false
            }
        });
        window.dispatchEvent(event);

    };

    if (!visible) return null; // don't render if not visible

    const formatEndDate = (dateString) => {
        const date = new Date(dateString);
        const options = { month: 'short', day: 'numeric', year: '2-digit' };
        return `Offer ends ${date.toLocaleDateString('en-US', options).replace(',', '').replace(' ', ' ').replace(' ', ' ')}`;
    };

    return ( 
        <div data-id={id} data-offer-id={offer_id} onClick={handleCouponBoxClick} 
            className={clsx(
                !isStoreOpen && 'tw-opacity-50',
                'category-box tw-relative tw-cursor-pointer tw-w-full tw-aspect-1 lg:tw-max-w-[300px] !tw-p-1  md:!tw-p-2 tw-flex tw-flex-col tw-justify-center tw-gap-2 tw-rounded-md',
            )} >
            {/* Image */}
            <span className='tw-relative tw-w-full tw-max-h-[228px] tw-flex tw-items-center tw-justify-center tw-bg-white tw-rounded-md tw-p-1 tw-border tw-border-solid tw-border-vroom-gray-400 product-img-wrapper'>
                <img loading='lazy' src={image_url} alt={title} className={clsx('tw-w-full tw-h-full tw-aspect-1 tw-object-contain')} />
            </span>
            {/* Details */}

            <section className='tw-flex tw-flex-col tw-w-full tw-text-center'>
                <span className='tw-h-14 tw-text-[18px] tw-font-medium tw-tracking-tight'>
                    {title}
                </span>
                <span className='tw-h-10 tw-text-[14px] tw-font-normal tw-tracking-tighter'>
                    {subtitle}
                </span>
                <span className='tw-text-[11px]  tw-tracking-tighter'>
                    {formatEndDate(end_date)}
                </span>
            </section>
        </div>
    );
}
export default CouponTile;